import styled, { css } from 'styled-components';
import theme from "../theme/theme";

export const Button = styled.button`
  display: flex;
  align-items: center;
  cursor: pointer;
  border: none;

  &:focus,
  &:focus-visible {
    outline: none;
  }

  outline: none;

  &::-moz-focus-inner {
    border: 0;
  }

  ${({ size }) => getSize(size)}

  ${({ size, iconAlign }) => getPadding(size, iconAlign)}

  ${({ fullwidth }) => fullwidth && getFullWidth()}
    
  ${({ disabled }) => disabled && getDisabled()}
    
  ${(props) => getVariant(props)}
`;

const getVariant = (props) => {
  switch (props.variant) {
    case 'primary':
      return css`
        background-color: ${theme.colors['primary'].bg.regular};
        color: ${theme.colors['neutral'].text.inverted};

        &:hover {
          background-color: ${theme.colors['primary'].bg.strong};
        }

        &:active {
          background-color: ${theme.colors['secondary-1'].bg.regular};
        }

        ${(props) =>
          props.disabled &&
          `
            background-color: ${theme.colors['neutral'].bg.stronger};
            color: ${theme.colors['neutral'].text.regular};
          `}
      `;

    case 'secondary':
      return css`
        background-color: transparent;
        box-shadow: inset 0 0 0 2px ${theme.colors['primary'].border.regular};
        color: ${theme.colors['primary'].text.regular};

        &:hover {
          background-color: ${theme.colors['primary'].bg.weak};
          box-shadow: inset 0 0 0 2px ${theme.colors['primary'].border.strong};
        }

        &:active {
          background-color: ${theme.colors['secondary-1'].bg.weak};
          box-shadow: inset 0 0 0 2px
            ${theme.colors['secondary-1'].border.strong};
        }

        ${(props) =>
          props.disabled &&
          css`
            box-shadow: inset 0 0 0 2px ${theme.colors['neutral'].border.strong};
            color: ${theme.colors['neutral'].text.regular};
          `}
      `;

    case 'tertiary':
      return css`
        background-color: transparent;
        color: ${theme.colors['primary'].text.regular};

        &:hover {
          color: ${theme.oldColors['palette-input-link-hover']};
        }

        &:active {
          color: ${theme.colors['primary'].text.regular};
        }

        ${(props) =>
          props.disabled &&
          css`
            color: ${theme.colors['neutral'].text.regular};
          `}
      `;

    //TODO: revisar al hacer el componente cuit
    case 'link':
      return css`
        color: ${theme.oldColors['palette-input-link-normal']};
        border: none;
        background-color: transparent;
        svg path[fill] {
          fill: ${theme.oldColors['palette-input-link-normal']};
        }

        &:hover {
          color: ${theme.oldColors['palette-input-link-hover']};

          svg path[fill] {
            fill: ${theme.oldColors['palette-input-link-hover']};
          }
        }
      `;
    case 'tertiary':
      return css`
        border: none;
        background-color: transparent;
        color: ${theme.colors['primary'].text.regular};
        svg path[fill] {
          fill: ${theme.colors['primary'].text.regular};
        }

        &:hover {
          color: ${theme.colors['primary'].text.strong};
          svg path[fill] {
            fill: ${theme.colors['primary'].text.strong};
          }
        }

        &:active {
          color: ${theme.colors['secondary-1'].text.strong};
          svg path[fill] {
            fill: ${theme.colors['secondary-1'].text.strong};
          }
        }

        ${props.disabled &&
      `
              color: ${theme.colors['neutral'].text.regular};
              svg path[fill] {
                fill: ${theme.colors['neutral'].text.regular};
              }
          `}
      `;
  }
};

const getSize = (size) => {
  switch (size) {
    case 'sm':
      return css`
        border-radius: ${theme.borderRadius['border-radius-5']};
        ${theme.textStyles['text-preset-7']};
      `;
    case 'md':
      return css`
        border-radius: ${theme.borderRadius['border-radius-5']};
        ${theme.textStyles['text-preset-6']};
      `;
    case 'lg':
      return css`
        border-radius: ${theme.borderRadius['border-radius-5']};
        ${theme.textStyles['text-preset-5']};
      `;
    case 'md-full':
      return css`
        border-radius: ${theme.borderRadius['border-radius-5']};
        ${theme.textStyles['text-preset-7']};
        ${getFullWidth()}
      `;
  }
};

const getPadding = (size, iconAlign) => {
  const paddingsBySize = {
    sm: {
      none: `
        ${theme.spacing['spacing-2']}
        ${theme.spacing['spacing-4']}`,
      left: `
        ${theme.spacing['spacing-2']}
        ${theme.spacing['spacing-4']}`,
      right: `
        ${theme.spacing['spacing-2']}
        ${theme.spacing['spacing-4']}`,
      center: `${theme.spacing['spacing-2']}`,
    },
    md: {
      none: `
        ${theme.spacing['spacing-3']}
        ${theme.spacing['spacing-5']}`,
      left: `
        ${theme.spacing['spacing-3']}
        ${theme.spacing['spacing-5']}`,
      right: `
        ${theme.spacing['spacing-3']}
        ${theme.spacing['spacing-5']}`,
      center: `${theme.spacing['spacing-3']}`,
    },
    lg: {
      none: `
          ${theme.spacing['spacing-4']}
          ${theme.spacing['spacing-6']}`,
      left: `
          ${theme.spacing['spacing-4']}
          ${theme.spacing['spacing-6']}`,
      right: `
          ${theme.spacing['spacing-4']}
          ${theme.spacing['spacing-6']}`,
      center: `${theme.spacing['spacing-4']}`,
    },
    'md-full': {
      none: `${theme.spacing['spacing-4']}`,
      left: `${theme.spacing['spacing-4']}`,
      right: `${theme.spacing['spacing-4']}`,
      center: `${theme.spacing['spacing-4']}`,
    },
  };

  return css`
    padding: ${paddingsBySize[size][iconAlign]};
    ${iconAlign === 'center' &&
    size !== 'md-full' &&
    `
          display: flex;
          justify-content: center;
          align-items: center; 
        `}

    i {
      margin-right: ${iconAlign === 'left' ? theme.spacing['spacing-3'] : 0};
      margin-left: ${iconAlign === 'right' ? theme.spacing['spacing-3'] : 0};
    }
  `;
};

const getFullWidth = () => css`
  width: 100%;
  justify-content: center;
`;

const getDisabled = () => css`
  cursor: not-allowed;
  pointer-events: none;
`;
